import React from "react";
import { Icon } from "components";
import { useStyles } from "./styles";
import { BATTERY_ONE_PART } from "entities/cars";

interface IconBatteryProps {
  batteryCharge: number;
}

export const IconBattery = ({ batteryCharge }: IconBatteryProps) => {
  const classes = useStyles();
  const batteryPart = Math.round(batteryCharge / BATTERY_ONE_PART);
  return (
    <Icon
      kind={`battery${batteryPart === 7 ? "Full" : `${batteryPart}Bar`}`}
      classes={{ root: classes.battery }}
    ></Icon>
  );
};
